import { render } from "./welcome-aboard-component.vue?vue&type=template&id=1faa114f"
import script from "./welcome-aboard-component.vue?vue&type=script&lang=js"
export * from "./welcome-aboard-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__